// Coordinates post-org-switch navigation.
//
// Clerk's <OrganizationSwitcher> no longer carries `afterSelectOrganizationUrl`
// (that prop made Clerk hard-navigate via window.location — a full page
// reload — because <ClerkProvider> isn't wired to the React Router instance).
// Instead, OrgBoundary performs a soft SPA redirect to "/" after a switch so
// the user lands on the org-type-appropriate overview.
//
// The custom switch handlers (NavSidebar "Back to Consultant", ConsultantOverview
// "open client") navigate to their OWN specific destinations. They call
// `markManualOrgNav(dest)` before `setActive` so OrgBoundary knows to skip its
// default redirect and let the handler's navigation stand.
//
// The claim now carries the destination PATH, not just a flag. OrgBoundary uses
// it to keep the switch loader up until the router actually reaches that path —
// the same causal gate the sidebar switch uses — so the handler's old route can
// never render against the new org for a frame (the /not-found flash). A bare
// `markManualOrgNav()` (no path) still works: it records `true`, meaning "a
// handler will navigate, destination unknown", and OrgBoundary falls back to
// dropping the loader once the switch work settles (no path to gate on).

let manualNavClaim = null; // string dest | true | null

export const markManualOrgNav = (dest = true) => {
  manualNavClaim = dest;
};

// Returns the destination path (string), `true` for a path-less claim, or
// `null` when no handler claimed this switch.
export const consumeManualOrgNav = () => {
  const claim = manualNavClaim;
  manualNavClaim = null;
  return claim;
};

// Reset the claim if a switch fails before OrgBoundary consumes it, so a stale
// claim can't suppress the redirect on the next (unrelated) switch.
export const clearManualOrgNav = () => {
  manualNavClaim = null;
};
